import React from "react"
import { Line } from "recharts"
import {
  CartesianGrid,
  Legend,
  LineChart as RechartsLineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

const LineChart = ({
  data,
  categories,
  categoryNames,
  index,
  colors,
  valueFormatter = (value) => value,
  yAxisValueFormatter = (value) => value,
  showLegend = true,
  showGridLines = true,
  showXAxis = true,
  showYAxis = true,
  yAxisWidth = 70,
  className = "",
}) => {
  // Format date for X-axis
  const formatXAxis = (tickItem) => {
    if (index === "date" && tickItem) {
      const date = new Date(tickItem);
      return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric' 
      });
    }
    return tickItem;
  };

  return (
    <ResponsiveContainer width="100%" height="100%" className={className}>
      <RechartsLineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray={showGridLines ? "3 3" : "0"} />
        {showXAxis && <XAxis dataKey={index} tickFormatter={formatXAxis} />}
        {showYAxis && <YAxis width={yAxisWidth} tickFormatter={yAxisValueFormatter} />}
        <Tooltip formatter={(value) => valueFormatter(value)} />
        {showLegend && <Legend />}
        {categories.map((category, i) => (
          <Line
            key={category}
            type="monotone"
            dataKey={category}
            name={categoryNames && categoryNames[i] ? categoryNames[i] : category}
            stroke={colors[i % colors.length]}
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 8 }}
          />
        ))}
      </RechartsLineChart>
    </ResponsiveContainer>
  )
}

export default LineChart;